export default __webpack_public_path__ + "static/media/55_Sojka_obecna_Roche_upr.01755437.mp3";